<template>
  <project-base :state="state">
    <div class="container mt-8">
      <team-section
        v-for="(partner, index) in partners"
        :key="partner.id"
        :type="partner.type"
        :partner-id="partner.id"
        :company="partner.company"
        :team="partner.users"
        :staff="partner.staff"
        :class="{
          'mb-24': index + 1 !== partners.length
        }"
      />
    </div>
  </project-base>
</template>

<script>
import { userProjectMixin } from '../../mixins/userProject'
export default {
  name: 'ProjectViewTeamIndex',
  mixins: [userProjectMixin],
  created() {
    window._project = this.project.uuid;
    window._user = Object.freeze({
      id: this.state.user.id,
      company_id: this.projectPartner.company_id,
      primary: this.projectPartner.primary,
      isLead: this.isLead,
      isPartner: this.isPartner,
      isViewer: this.isViewer,
      isEditor: this.isEditor,
      isMonitor: (this.state.user.is_monitor > 0)
    });
		document.title = `Project ${ this.state.project.ref } Team :: ${document.title}`;
  },
  destroyed() {
    delete window._user;
  }
}
</script>
